import cx from 'classnames'
import styled from 'styled-components'

export const StyledMessageWrapper = styled.div`
  margin-top: 8px;
`

export const StyledModalContent = styled.div.attrs({
  className: cx('tds-u-mt3')
})`
  padding-left: 8px;
`

export const StyledDeviationsList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`

export const StyledParagraph = styled.p`
  margin-top: 0;
  margin-bottom: 2px;
`

export const StyledDiv = styled.div`
  margin-left: 22px;
  padding-left: 4px;
`

export const StyledButtonsWrapper = styled.div`
  margin-left: 22px;
`
